import type React from 'react';

const isVisible = (element: HTMLElement) => {
  const styles = window.getComputedStyle(element);
  return styles.display !== 'none' && styles.visibility !== 'hidden';
};

export const selectActiveMentionOnTab = (event: React.KeyboardEvent<HTMLElement>) => {
  if (event.key !== 'Tab' || event.shiftKey) return;

  const openDropdown = Array.from(
    document.querySelectorAll<HTMLElement>('.ant-mentions-dropdown')
  ).find(isVisible);
  const activeOption = openDropdown?.querySelector<HTMLElement>(
    '.ant-mentions-dropdown-menu-item-active, [aria-selected="true"]'
  );

  if (!activeOption) return;

  event.preventDefault();
  event.stopPropagation();
  activeOption.click();
};
